import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('marketFilters', {
        template: require('./marketFiltersComponent.html'),
        bindings: {
            filters: '<',
            onFilterRemoving: '&',
            readOnly: '<'
        },
        controller: [AgGridService.componentName, angularServicesNames.$translate, '$scope', function(
            this: $TSFixMe,
            agGridService: AgGridService,
            $translate: ng.translate.ITranslateService,
            $scope: $TSFixMe
        ) {
            var $ctrl = this;

            $ctrl.$onInit = function () {
                $scope.$watchCollection('$ctrl.filters', () => refreshGrid());
            };

            $ctrl.removeFilter = (data: $TSFixMe) => {
                $ctrl.onFilterRemoving({ filter: data });
            }

            $scope.$on('LanguageChanged', () => agGridService.refreshGridLanguage($ctrl.gridApi));

            $ctrl.filterGridOptions = {
                columnDefs: [
                    {
                        field: 'brand', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.BRAND"),
                        tooltipField: 'brand',
                        filterParams: { newRowsAction: 'keep' }, filter: "agTextColumnFilter"
                    },
                    {
                        field: 'molecules', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.MOLECULES"),
                        filterParams: { newRowsAction: 'keep' }, filter: "agSetColumnFilter",
                        cellRenderer: () => '<div class="ui-grid-cell-contents" title="{{ data.molecules | join: \',\' }}"><span ng-repeat-start="m in data.molecules">{{m}}<span ng-if="!$last">, </span></span><span ng-repeat-end=""></span></div>'
                    },
                    {
                        field: 'onlySelectedMolecues', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.ONLY_SELECTED_MOLECUES"),
                        editable: false,
                        template: '<div class="ui-grid-cell-contents"><input type="checkbox" class="checkbox" ng-checked="{{data.onlySelectedMolecues}}" readonly="readonly" /></div>'
                    },
                    {
                        field: 'moleculeType', headerValueGetter: () => 'MONO/COMBO'
                    },
                    {
                        field: 'pharmacyMarket', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.PHARMACY_MARKET"), width: 80,
                        filterParams: { newRowsAction: 'keep' }, filter: 'agSetColumnFilter',
                        tooltipField: 'pharmacyMarket'
                    },
                    {
                        field: 'perscirptionMarket', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.PRESCRIPTION_MARKET"),
                        filterParams: { newRowsAction: 'keep' }, filter: 'agSetColumnFilter',
                        width: 80, tooltipField: "perscirptionMarket"
                    },
                    {
                        field: 'sku', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.SKU"),
                        filterParams: { newRowsAction: 'keep' }, filter: "agTextColumnFilter",
                        tooltipField: 'sku'
                    },
                    {
                        field: 'atc3', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.ATCOTC3"),
                        filterParams: { newRowsAction: 'keep' }, filter: "agTextColumnFilter",
                        tooltipField: 'atcOtc3'
                    },
                    {
                        field: 'atc4', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.ATCOTC4"),
                        filterParams: { newRowsAction: 'keep' }, filter: "agTextColumnFilter",
                        tooltipField: 'atcOtc4'
                    },
                    {
                        field: 'nfc3', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.NFC3"),
                        filterParams: { newRowsAction: 'keep' }, filter: "agTextColumnFilter",
                        cellRenderer: () => '<div class="ui-grid-cell-contents"> <span ng-repeat-start="x in data.nfc3">{{x}}<span ng-if="!$last">, </span></span><span ng-repeat-end=""></span></div>'
                    },
                    {
                        field: 'type', headerValueGetter: () => 'typ',
                        filterParams: { newRowsAction: 'keep' }, filter: 'agSetColumnFilter',
                        tooltipField: 'type'
                    },
                    {
                        field: 'actions', headerValueGetter: () => $translate.instant("ACTIONS"),
                        cellRenderer: () => '<div class="ui-grid-cell-contents"><a ng-if="!$ctrl.readOnly" href="#" ng-click="$ctrl.removeFilter(data)"><i class="glyphicon glyphicon-remove"></i></a></div>', width: 70,
                    },
                ],
                angularCompileRows: true,
                defaultColDef: { 
                    sortable: true,
                    resizable: true
                },
                enableFilter: false,
                animateRows: true,
                floatingFilter: true,
                pagination: true,
                paginationPageSize: 10,
                localeTextFunc: agGridService.transalteFunc,
                suppressHorizontalScroll: true,
                domLayout: 'autoHeight',
                onGridReady: (config: $TSFixMe) => {
                    $ctrl.gridApi = config.api;
                    config.api.sizeColumnsToFit();
                    refreshGrid();
                },
                onGridSizeChanged: (config: $TSFixMe) => {
                    config.api.sizeColumnsToFit();
                }
            };

            function refreshGrid() {
                if ($ctrl.gridApi && $ctrl.filters) {
                    $ctrl.gridApi.setRowData($ctrl.filters);
                }
            }

            function checkboxCellRenderer (params: $TSFixMe){
                var input = document.createElement("input")
                input.type = "checkbox";
                input.checked = params.value
                return input
              }
        }]
    })

})(angular.module('topline.modules'));